import type {
  AdminSuggestMenteeMenteeType,
  AdminSuggestMentorMentorType,
  MenteeMatchingConfirmationDTOType,
  MenteeMatchingConfirmationResponseType,
  MenteeMatchingDTOType,
  MenteeMatchingResponseType,
  MentorMatchingDTOType,
} from '@/features/matching/types'
import fetchClient, { fetchSSE } from '@/lib/fetch'

export async function menteeMatchSuggestMentorMutation(
  data: MenteeMatchingDTOType,
): Promise<MenteeMatchingResponseType> {
  return fetchClient(`/v2/groups/matchmaking/suggest?programId=${data.programId}`, {
    method: 'POST',
    body: JSON.stringify({
      criteria: data.criteria,
    }),
  })
}

export async function menteeMatchConfirmMutation(
  data: MenteeMatchingConfirmationDTOType,
): Promise<MenteeMatchingConfirmationResponseType> {
  return fetchClient('/v2/groups/matchmaking/match', {
    method: 'POST',
    body: JSON.stringify(data),
  })
}

export async function mentorMatchFillCriteriaMutation(data: MentorMatchingDTOType) {
  return fetchClient('/v2/groups/matchmaking/criteria', {
    method: 'POST',
    body: JSON.stringify(data),
  })
}

export async function menteeFillCriteriaMutation(data: MenteeMatchingDTOType) {
  return fetchClient('/v2/groups/matchmaking/criteria', {
    method: 'POST',
    body: JSON.stringify(data),
  })
}

export async function adminSuggestMentorStream(
  data: { programId: string; menteeId: string },
  onMentor: (mentor: AdminSuggestMentorMentorType) => void,
  onDone: () => void,
  onError?: (error: string) => void,
): Promise<void> {
  await fetchSSE(
    '/v2/groups/matchmaking/admin/suggest',
    {
      method: 'POST',
      body: JSON.stringify(data),
    },
    (event, payload) => {
      if (event === 'mentor') {
        onMentor(payload as AdminSuggestMentorMentorType)
      } else if (event === 'done') {
        onDone()
      } else if (event === 'error') {
        onError?.(payload.message || 'Unknown error')
      }
    },
  )
}

export async function adminSuggestMenteeStream(
  data: { programId: string; mentorId: string },
  onMentee: (mentee: AdminSuggestMenteeMenteeType) => void,
  onDone: () => void,
  onError?: (error: string) => void,
): Promise<void> {
  await fetchSSE(
    '/v2/groups/matchmaking/admin/suggest-mentee',
    {
      method: 'POST',
      body: JSON.stringify(data),
    },
    (event, payload) => {
      if (event === 'mentee') {
        onMentee(payload as AdminSuggestMenteeMenteeType)
      } else if (event === 'done') {
        onDone()
      } else if (event === 'error') {
        onError?.(payload.message || 'Unknown error')
      }
    },
  )
}
